import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ICheckBuilder from "../../../../toolkit/baseForms2/iCheckBuilder/ICheckBuilder";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";

export type Inputs =
  | "modo"
  | "observaciones"
  | "idMembresiaActualizacion"
  | "tipoOperacionActualizacion"
  | "ignorarMantenimiento"
  | "ignorarExpediente"
  | "ignorarMedioPago"
  | "ignorarMedioPagoDocumento";
export type Buttons = "aceptar" | "cancelar";

export const gestionFormConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "modo",
      label: "Modalidad",
      bts: { mCol: 12 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Establecida por el sistema",
        data: [
          { value: "ALCANCE", label: "Solo alcance" },
          { value: "DESCARTADA", label: "Descartada" }
        ]
      }
    },
    {
      name: "observaciones",
      label: "Observaciones",
      bts: { mCol: 12 },
      component: ITextBuilder,
      props: {
        rows: 4
      }
    },
    {
      name: "idMembresiaActualizacion",
      label: "Tipo de membresía",
      bts: { mCol: 12 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Tipo original"
      }
    },
    {
      name: "tipoOperacionActualizacion",
      label: "Tipo de operación",
      bts: { mCol: 12 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Tipo original",
        data: [
          { value: "VENTA_MEMBRESIA", label: "Venta de membresía" },
          { value: "REACTIVACION", label: "Reactivación" },
          { value: "INTEGRANTE_INDIVIDUAL", label: "Integrante individual" }
        ]
      }
    },
    {
      name: "ignorarMantenimiento",
      label: "Ignorar validación de mantenimiento",
      bts: { mCol: 6 },
      component: ICheckBuilder,
      props: {}
    },
    {
      name: "ignorarExpediente",
      label: "Ignorar validación de expediente",
      bts: { mCol: 6 },
      component: ICheckBuilder,
      props: {}
    },
    {
      name: "ignorarMedioPago",
      label: "Ignorar validación de medio de pago",
      bts: { mCol: 6 },
      component: ICheckBuilder,
      props: {}
    },
    {
      name: "ignorarMedioPagoDocumento",
      label: "Ignorar validación de documento CAT",
      bts: { mCol: 6 },
      component: ICheckBuilder,
      props: {}
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Guardar",
      isSubmit: true,
      bts: { mCol: 6 },
      component: IButtonBuilder
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: { mCol: 6 },
      component: IButtonBuilder
    }
  ],
  validations: {},
  rows: [
    ["modo"],
    ["tipoOperacionActualizacion"],
    ["idMembresiaActualizacion"],
    ["ignorarMantenimiento", "ignorarExpediente"],
    ["ignorarMedioPago", "ignorarMedioPagoDocumento"],
    ["observaciones"],
    ["aceptar", "cancelar"]
  ]
};
